<template>
  <div v-if="isOpen" class="modal-overlay" role="dialog" aria-modal="true">
    <div class="modal-container">
      <!-- Modal Header -->
      <div class="modal-header">
        <h3 class="modal-title">Time Entry</h3>
        <soft-button
          color="danger"
          size="sm"
          class="close-btn"
          aria-label="Close"
          @click="closeModal"
        >
          ×
        </soft-button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form @submit.prevent="submit_time_entry" class="form-container">
          <!-- <soft-input
            v-model="formData.service_code"
            type="number"
            placeholder="Service Code"
            name="service_code"
            size="lg"
          /> -->
          <soft-select
            v-model="formData.service_code"
            :options="formattedServiceCodes"
            label="Service Code"
            placeholder="-- Select Service Code --"
            required
            class="form-control mb-3"
          />

          <label>Start Date</label>
          <soft-input
            v-model="formData.start_date"
            type="date"
            @change="calculate"
            name="start_date"
            size="lg"
          />

          <label>Start Time</label>
          <soft-input
            v-model="formData.start_time"
            type="time"
            @change="calculate"
            name="start_time"
            size="lg"
          />

          <label>End Date</label>
          <soft-input
            v-model="formData.end_date"
            type="date"
            @change="calculate"
            name="end_date"
            size="lg"
          />

          <label>End Time</label>
          <soft-input
            v-model="formData.end_time"
            type="time"
            @change="calculate"
            name="end_time"
            size="lg"
          />

          <label>Total Hours</label>
          <span class="form-control" id="Total_hrs">
            {{ formData.total_hours || "0.00" }} Hrs
          </span>

          <label>Specifications:</label>
          <soft-text-area
            v-model="formData.specification"
            placeholder="Please specify task done in this time entry"
            size="lg"
          />

          <soft-button
            color="success"
            size="lg"
            type="submit"
            class="submit-btn"
          >
            Submit
          </soft-button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import SoftInput from "@/components/SoftInput.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftTextArea from "@/components/SoftTextarea.vue";
import SoftSelect from "@/components/SoftSelect.vue";
import Swal from "sweetalert2";
import axios from "axios";
import alertify from "alertifyjs";

export default {
  props: {
    isOpen: Boolean,
  },
  components: {
    SoftInput,
    SoftButton,
    SoftTextArea,
    SoftSelect,
  },
  data() {
    return {
      formData: {
        start_date: "",
        start_time: "",
        end_date: "",
        end_time: "",
        service_code: "",
        total_hours: null,
        specification: "",
      },
      serviceCodes: [],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async submit_time_entry() {
      if (!this.formData.total_hours || this.formData.total_hours <= 0) {
        return alertify.error("Invalid Time");
      }

      const token = localStorage.getItem("token");
      const payload = {
        ...this.formData,
        client_id: localStorage.getItem("selectedClientId"),
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/timesheet_entry`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === 201) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.closeModal();
        } else if (response.data.status > 400) {
          alertify.error(
            `${response.data.message} Available hours for this week: ${response.data.available_hours}`
          );
        }
      } catch (error) {
        const errors = error.response.data.errors;

        // Flatten all error messages into a single array
        const errorMessages = Object.values(errors).flat();

        console.error(error);
        alertify.error("Failed to submit time entry. " + errorMessages);
      }
    },
    calculate() {
      const { start_date, start_time, end_date, end_time } = this.formData;

      if (start_date && start_time && end_date && end_time) {
        const start = new Date(`${start_date}T${start_time}`);
        const end = new Date(`${end_date}T${end_time}`);
        const diff = (end - start) / (1000 * 60 * 60);
        this.formData.total_hours = diff > 0 ? diff.toFixed(2) : 0;
      }
    },
    async fetch_employee_data() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BACKEND_DOMAIN}/api/fetch-employee-data`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (res.data.success) {
          let codesString = res.data.data.service_code || "";
          codesString = codesString.replace(/["[\]]/g, "");
          this.serviceCodes = codesString.split(",").map((code) => code.trim());
        }
      } catch (err) {
        console.error("Failed to fetch employee data", err);
        Swal.fire("Error", "Could not fetch employee data", "error");
      }
    },
  },
  mounted() {
    this.fetch_employee_data();
  },
  computed: {
    formattedServiceCodes() {
      return this.serviceCodes.map((code) => ({
        label: code,
        value: code,
      }));
    },
  },
};
</script>

<style scoped>
/* Overlay */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Modal container: use px max-width (not vw) so it won't shrink on phones */
.modal-container {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.18);
  width: 100%;
  max-width: 620px; /* desktop cap */
  max-height: calc(100vh - 40px); /* keep modal within viewport */
  overflow: hidden;
  padding: 1.25rem 1.25rem 1.5rem;
  position: relative;
  box-sizing: border-box;
}

/* Header title left; close button is absolute top-right */
.modal-header {
  /* no flex wrapping needed; title sits naturally and close is absolute */
  margin-bottom: 0.75rem;
}

.modal-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #222;
  padding-right: 48px; /* avoid overlap with absolute close button */
}

/* Close button absolute so it never wraps */
.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  min-width: 36px;
  height: 36px;
  padding: 0 8px;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

/* Modal body scrolls inside */
.modal-body {
  overflow-y: auto;
  max-height: calc(100vh - 140px);
  padding-top: 0.25rem;
}

/* Form layout */
.form-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Ensure custom components / native fields fill available width */
.modal-container soft-input,
.modal-container soft-text-area,
.modal-container .form-control,
.modal-container input,
.modal-container textarea {
  width: 100%;
  box-sizing: border-box;
}

/* Make submit button full width but don't affect close button */
.submit-btn {
  width: 100%;
  margin-top: 6px;
}

/* Lighter field look for Total_hrs */
#Total_hrs.form-control {
  background-color: #f6f7f8;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  display: inline-block;
}

/* Small screens adjustments */
@media (max-width: 480px) {
  .modal-container {
    padding: 0.9rem;
    max-width: 95%;
  }
  .modal-title {
    font-size: 1.05rem;
    padding-right: 44px;
  }
  .close-btn {
    top: 16px;
    right: 16px;
    min-width: 42px;
    height: 42px;
  }
  .modal-body {
    max-height: calc(100vh - 120px);
  }
}
</style>
